import DemoMonarchSpecRouteScreen from "../../../../src/features/arrangements/screens/DemoMonarchSpecRouteScreen";

export default function LegacyArrangementStartRoute() {
  return <DemoMonarchSpecRouteScreen fixedPath="arrangements/start" />;
}
